module.exports = __webpack_public_path__ + "img/photo-wide-4.ac9422d8.jpg";